import { Link } from "@inertiajs/react";

type CourseTypeCardProps = {
  title: string;
  description: string;
  image: string;
  href: string;
};

/** Carousel item for the landing page's "tipos de curso" section. */
export default function CourseTypeCard({
  title,
  description,
  image,
  href,
}: CourseTypeCardProps) {
  return (
    <Link
      href={href}
      className="block w-56 shrink-0 snap-start overflow-hidden rounded-3xl border border-ink/20 bg-white shadow-sm transition-shadow hover:shadow-md sm:w-64"
    >
      <img
        src={image}
        alt={title}
        className="aspect-square w-full object-cover"
      />
      <div className="p-4">
        <h3 className="font-sans text-lg font-semibold text-ink uppercase">
          {title}
        </h3>
        <p className="mt-1 text-justify font-display text-xs font-light leading-relaxed text-ink/80">
          {description}
        </p>
      </div>
    </Link>
  );
}
